import { referalSettingsAPI } from "../api";
import { SET_REFERAL_SETTINGS } from "./actionTypes";

export const fetchReferalSettings = () => {
  return async (dispatch) => {
    try {
      const response = await referalSettingsAPI();
      dispatch({
        type: SET_REFERAL_SETTINGS,
        payload: response.result,
      });
    } catch (err) {}
  };
};
